module.exports = __webpack_public_path__ + "static/media/visitDetailsGray.ec612c8d.png";